import { CONNECTION_REFERENCE_MD } from "./skill-content/connection.js";
import { LOCAL_FILES_REFERENCE_MD } from "./skill-content/local-files.js";
import { VISUAL_RECAP_SKILL_MD } from "./skill-content/visual-recap-skill.js";
import { WIREFRAME_REFERENCE_MD } from "./skill-content/wireframe.js";

export { CONNECTION_REFERENCE_MD, VISUAL_RECAP_SKILL_MD };

export const RECAP_REFERENCE_FILES = {
  "references/wireframe.md": WIREFRAME_REFERENCE_MD,
  "references/connection.md": CONNECTION_REFERENCE_MD,
  "references/local-files.md": LOCAL_FILES_REFERENCE_MD,
};
